import ViewModuleIcon from "@mui/icons-material/ViewModule";

// Central icon for modules. Replace here to update everywhere.
export default ViewModuleIcon;
